const constants = {
  GAME_LENGTH: 10
};

export default constants;
